import { GAL_PER_ACRE_INCH } from './constants'

// For acre-inch/acre-feet registers (× 0.001, × 0.01), the decimal on the
// physical register IS the multiplier made visible. If the user types it,
// we strip it and pad to the expected decimal places so the × multiplier
// still produces the correct value.  Whole-number entries (old format) pass
// through unchanged, so existing stored readings stay compatible.
export function normalizeReading(valueStr, units) {
  const str = String(valueStr ?? '').trim()
  if (!str || !units?.includes('× 0.0')) return parseFloat(str) || 0
  if (!str.includes('.')) return parseFloat(str) || 0

  const multiplier = units.match(/× (0\.0+\d*)/)?.[1]
  if (!multiplier) return parseFloat(str) || 0

  const decimalPlaces = multiplier.length - 2
  const [whole, frac = ''] = str.split('.')
  const paddedFrac = frac.padEnd(decimalPlaces, '0').substring(0, decimalPlaces)
  return parseFloat(whole + paddedFrac) || 0
}

export function calculateInches(start, end, acres, units) {
  const startVal = normalizeReading(start, units)
  const endVal = normalizeReading(end, units)
  const acresVal = parseFloat(acres) || 0

  let reading = endVal - startVal

  if (reading < 0) {
    const digits = startVal.toString().split('.')[0].length
    const maxVal = Math.pow(10, digits) - 1
    reading = (maxVal - startVal) + endVal + 1
  }

  let acreInches = 0

  switch(units) {
    case 'Gallons × 1':
      acreInches = reading / GAL_PER_ACRE_INCH
      break
    case 'Gallons × 10':
      acreInches = (reading * 10) / GAL_PER_ACRE_INCH
      break
    case 'Gallons × 100':
      acreInches = (reading * 100) / GAL_PER_ACRE_INCH
      break
    case 'Gallons × 1000':
      acreInches = (reading * 1000) / GAL_PER_ACRE_INCH
      break
    case 'Acre-Inches × 0.001':
      acreInches = reading * 0.001
      break
    case 'Acre-Inches × 0.01':
      acreInches = reading * 0.01
      break
    case 'Acre-Inches McCrometer FlowCom':
      acreInches = reading
      break
    case 'Acre-Feet × 0.001':
      acreInches = reading * 0.001 * 12
      break
    case 'Acre-Feet McCrometer FlowCom':
      acreInches = reading * 12
      break
    default:
      acreInches = (reading * 100) / GAL_PER_ACRE_INCH
  }

  const inchesPerAcre = acresVal > 0 ? (acreInches / acresVal) : 0
  return inchesPerAcre.toFixed(2)
}

export function calculateAcreInches(inches, acres) {
  return (parseFloat(inches) * parseFloat(acres)).toFixed(1)
}
